'use strict';

function contactService($http, upload) {
  var contactBaseUrl = '/api/customer/contact/';
  var contactCsvImportURL = '/api/customer/csv-parser/';
  return {
    contactCsvImport: contactCsvImport,
    createContact: createContact,
    listContacts: listContacts,
    deleteContact: deleteContact
  };
  function listContacts(global) {
    return $http.get(contactBaseUrl + (global ? '?global=true': ''));
  }

  function contactCsvImport(file) {
    return upload({ url: contactCsvImportURL, method: 'POST', data: { file: file } });
  }

  function createContact(contact, global) {
    return $http.post(contactBaseUrl + (global ? '?global=true': ''), contact);
  }

  function deleteContact(contact) {
    return $http.delete(contactBaseUrl + contact.id);
  }
}
module.exports = contactService;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/services/contact.service.js
 ** module id = 315
 ** module chunks = 0
 **/